import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../../../utils/axios";
import {
  MIDDLE_WARE_BASE_URL_v1,
  CALL_PPOR_API
} from "../../../utils/CONSTANTS";

const initialState = {
  ImageState: "pending",
  insertProfileImageUpdate: null,
};
export const profileImagePage: any = createAsyncThunk(
  "get/profileImagePage",
  async (data: any) => {
    const response = await axios.postStringRequest(
      MIDDLE_WARE_BASE_URL_v1() + CALL_PPOR_API(),
      data
    );
    return response;
  }
);

const profileImagePageSlice = createSlice({
  name: "profileImagePage",
  initialState,
  reducers: {},
  extraReducers: (builder) =>
    builder
      .addCase(profileImagePage.pending, (profileImageState) => {
        profileImageState.ImageState = "pending";
      })
      .addCase(profileImagePage.fulfilled, (profileImageState, action) => {
        let tempRes = action.payload.data?.response;
        if (typeof tempRes === "string") {
          tempRes = JSON.parse(tempRes);
        }

        profileImageState.ImageState = "fulfilled";
        profileImageState.insertProfileImageUpdate = tempRes?.response;
      })
      .addCase(profileImagePage.rejected, (profileImageState) => {
        profileImageState.ImageState = "failed";
      }),
});

export const updateImage = (state: any) => state.profileImagePage;

export default profileImagePageSlice.reducer;
